import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/bug-reports";

export function create(data) {
  return axios.post(BASE, data);
}

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function setSeen(id, seen) {
  return axios.patch(`${BASE}/${id}/seen`, { seen });
}
